import axiosClient from './axiosClient';

export const getBudgets = () => axiosClient.get('/api/budgets');

export const createBudget = (payload) => axiosClient.post('/api/budgets', payload);

export const updateBudget = (id, payload) => axiosClient.put(`/api/budgets/${id}`, payload);

export const deleteBudget = (id) => axiosClient.delete(`/api/budgets/${id}`);
